"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Yup = tslib_1.__importStar(require("yup"));
var validation_1 = require("../../utils/validation");
exports.nameValidation = Yup.string()
    .max(40, 'Must be 40 characters or less.')
    .required('This field cannot be left empty.')
    .test('is-valid-name', 'Please enter a name only containing letters. Hyphens and spaces may also be used between names.', validation_1.isNameFormat);
exports.accountNumberValidation = Yup.string()
    .required('This field cannot be left empty.')
    .test('is-account-number', 'Please enter a valid account number.', validation_1.isAccountNumberFormat);
exports.accountNumberCoreValidation = Yup.string()
    .required('Please enter account number.')
    .test('is-account-number', 'Must be 9 characters.', validation_1.isAccountNumberCoreFormat);
exports.fuelAccountNumberValidation = Yup.string()
    .required('Please enter a Electricity or Gas number.')
    .test('is-fuel-account-number', 'Must be 11 characters.', validation_1.isFuelAccountNumberFormat);
exports.dateValidation = Yup.string()
    .required('Please enter your date of birth.')
    .test('is-less-age-110', 'Please contact us.', validation_1.isLessAge110)
    .test('is-over-age-18', 'You must be over 18 years of age.', validation_1.isOverAge18)
    .test('is-date-format', 'Please enter a valid date', validation_1.isDateFormat);
//# sourceMappingURL=CustomerAuth.validations.js.map